<template>
  <div>
    <el-card>
      <!-- 功能 -->
      <div class="header-menu">
        <el-form :inline="true" style="display: flex;flex-wrap: wrap;">
          <el-form-item label="老师名称" style="display: flex;width: 30%;">
            <el-select class="select" filterable clearable v-model="fromState.teacherId" placeholder="请选择老师名称">
              <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                :label="teacher.realname" :value="teacher.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学科" style="display: flex;width: 30%;">
            <el-select placeholder="请选择科目" v-model="fromState.discipline" clearable filterable>
              <el-option v-for="item in optionList4" :key="item.value" :value="item.tepys"
                :label="item.tepys"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学段" style="display: flex;width: 33%;">
            <el-select class="select" filterable clearable v-model="fromState.period" placeholder="请选择">
              <el-option value="初中" label="初中">
              </el-option>
              <el-option value="高中" label="高中">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期:" style="display: flex;width: 33%;">
            <el-date-picker v-model="fromState.timer" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="所在地域:" style="display: flex;width: 33%;">
            <el-select v-model="fromState.regionName" clearable filterable placeholder="请选择所在地域" >
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>

          <el-row>

            <el-col  style="text-align: right;">
              <el-button type="primary" icon="el-icon-search" @click="searchStudent" size="small"
                class="btns">查询</el-button>
              <el-button @click="handleClearList" class="btns" size="small" icon="el-icon-close">清除</el-button>
            </el-col>
          </el-row>


        </el-form>

        <el-button type="primary" @click="editById(1)" size="small" class="btns"
          style="float: right;margin-top: 30px; margin-right: 50px;">添加</el-button>
        <el-button type="primary" @click="editAchievement" size="small" class="btns"
          style="float: right;margin-top: 30px; margin-right: 50px;">老师周测成绩次数</el-button>

      </div>
      <!-- 查询学生列表-->
      <el-table :data="weeklyTestList" :stripe="true" :highlight-current-row="true">
        <!-- <el-table-column label="序号" type="selection"></el-table-column> -->
        <el-table-column prop="teacherName" label="老师名称" width="100">
        </el-table-column>
        <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
        <el-table-column prop="period" label="学段">

        </el-table-column>
        <el-table-column label="学科" prop="discipline">

        </el-table-column>
        <el-table-column label="第一周" prop="detailedGradesStr">
          <template slot-scope="scope">
            <div style="color: limegreen" v-if="scope.row.detailedGradesStr[0].isExcellent === 0">{{
              scope.row.detailedGradesStr[0].score }}</div>
               <div style="color: #E6A23C;" v-if="scope.row.detailedGradesStr[0].isExcellent === 1">{{
              scope.row.detailedGradesStr[0].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[0].isExcellent === 2">{{
              scope.row.detailedGradesStr[0].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[0].isExcellent === null">{{
              scope.row.detailedGradesStr[0].score }}</div>
              <div style="color: red;" v-if="scope.row.detailedGradesStr[0].score === null">缺考</div>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="detailedGradesStr[0].date">
        </el-table-column>
        <el-table-column label="第二周" prop="detailedGradesStr">
          <template slot-scope="scope" v-if="scope.row.detailedGradesStr[1]">
            <div style="color: limegreen" v-if="scope.row.detailedGradesStr[1].isExcellent === 0">{{
              scope.row.detailedGradesStr[1].score }}</div>
               <div style="color: #E6A23C;" v-if="scope.row.detailedGradesStr[1].isExcellent === 1">{{
              scope.row.detailedGradesStr[1].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[1].isExcellent === 2">{{
              scope.row.detailedGradesStr[1].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[1].isExcellent === null">{{
              scope.row.detailedGradesStr[1].score }}</div>
              <div style="color: red;" v-if="scope.row.detailedGradesStr[1].score === null">缺考</div>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="detailedGradesStr[1].date">
        </el-table-column>
        <el-table-column label="第三周" prop="detailedGradesStr">
          <template slot-scope="scope" v-if="scope.row.detailedGradesStr[2]">
            <div style="color: limegreen" v-if="scope.row.detailedGradesStr[2].isExcellent === 0">{{
              scope.row.detailedGradesStr[2].score }}</div>
               <div style="color: #E6A23C;" v-if="scope.row.detailedGradesStr[2].isExcellent === 1">{{
              scope.row.detailedGradesStr[2].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[2].isExcellent === 2">{{
              scope.row.detailedGradesStr[2].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[2].isExcellent === null">{{
              scope.row.detailedGradesStr[2].score }}</div>
              <div style="color: red;" v-if="scope.row.detailedGradesStr[2].score === null">缺考</div>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="detailedGradesStr[2].date">
        </el-table-column>
        <el-table-column label="第四周" prop="detailedGradesStr">
          <template slot-scope="scope" v-if="scope.row.detailedGradesStr[3]">
            <div style="color: limegreen" v-if="scope.row.detailedGradesStr[3].isExcellent === 0">{{
              scope.row.detailedGradesStr[3].score }}</div>
               <div style="color: #E6A23C;" v-if="scope.row.detailedGradesStr[3].isExcellent === 1">{{
              scope.row.detailedGradesStr[3].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[3].isExcellent === 2">{{
              scope.row.detailedGradesStr[3].score }}</div>
            <div style="color: red;" v-if="scope.row.detailedGradesStr[3].isExcellent === null">{{
              scope.row.detailedGradesStr[3].score }}</div>
              <div style="color: red;" v-if="scope.row.detailedGradesStr[3].score === null">缺考</div>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="detailedGradesStr[3].date">
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editById(2, scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" @click="details(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 弹出周测成绩添加 -->
      <el-dialog :title="titleTepy ? '周测成绩添加' : '周测成绩编辑'" :visible.sync="visibleForm" width="70%" @close="cancelUpd" :close-on-click-modal = false>
        <el-form ref="editFormData" :inline="true">
          <el-form-item label="老师名称:" style="width: 40%;">
            <el-select class="select" filterable clearable placeholder="请选择老师名称" style="width:100%;"
              v-model="editFormData.id">
              <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                :label="teacher.realname" :value="teacher.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="老师职级:" style="width: 40%;">
            <el-select placeholder="请选择职级" style="width: 100%" clearable filterable v-model="editFormData.jobname">
              <el-option v-for="source in getStudentsArr" :key="source.jobId" :value="source.jobId"
                :label="source.jobName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学科">
            <el-select placeholder="请选择科目" style="width: 100%" clearable filterable v-model="editFormData.Subject">
              <el-option v-for="item in optionList4" :key="item.value" :value="item.tepys"
                :label="item.tepys"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学段">
            <el-select class="select" filterable clearable placeholder="请选择" style="width:100%;"
              v-model="editFormData.Grade">
              <el-option value="初中" label="初中">
              </el-option>
              <el-option value="高中" label="高中">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="width: 100%; text-align: center;line-height: 80px;">周测考试日期</div>

          <div style="display: flex;" v-for="(itme, index) in editFormData.listData" :key="index">
            <div style=" padding-top: 8px;margin-right: 10px; font-size: 25px;">
              <i style="color: #00a0ff;" @click="handleAdd(1, { score: '', date: '', isExcellent: '', })"
                class="el-icon-circle-plus-outline"></i>
              <i style="color: #00a0ff;" v-show="index > 0" @click="handleAdd(2, index)"
                class="el-icon-remove-outline"></i>
            </div>
            <div>
              <el-form-item :label="'第' + (index + 1) + '周'">
                <el-input v-model="itme.score" type="text" placeholder="请输入分数" />
              </el-form-item>
              <el-form-item label="日期：">
                <el-date-picker style="margin-left: 20px;" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                  clearable v-model="itme.date"> </el-date-picker>
              </el-form-item>
              <el-form-item >
                <el-radio-group class="sex" v-model="itme.isExcellent">
                  <el-radio :label="0">优异</el-radio>
                  <el-radio :label="1">达标</el-radio>
                  <el-radio :label="2">不达标</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelUpd">取 消</el-button>
          <el-button type="primary" @click="commit()">提 交</el-button>
        </div>
      </el-dialog>

      <!-- 周测成绩详情 -->
      <el-dialog title="周测成绩详情" :visible.sync="visibleDetails" width="70%">
        <div class="namestyle">
          <div class="centstyle">老师名称：{{ detaiList.teacherName }}</div>
          <div class="centstyle">老师职级：{{ detaiList.teacherRankName }}</div>
        </div>
        <div class="namestyle">
          <div class="centstyle">学科：{{ detaiList.discipline }}</div>
          <div class="centstyle">学段：{{ detaiList.period }}</div>
        </div>
        <div style="width: 100%; text-align: center;line-height: 60px;">周测考试日期</div>
        <div class="weekstyle" v-for="(item, index) in detaiList.detailedGradesStr" :key="index">
          <div class="centstyle">第{{detaiList.detailedGradesStr.length - index}}周：{{ item.score }}</div>
          <div class="centstyle">日期：{{ item.date }}</div>
          <div class="centstyle">是否达到优异等级：{{ item.isExcellent === 0 ? '是' : '否' }}</div>
        </div>

      </el-dialog>

      <!-- 老师周测成绩次数 -->
      <el-dialog title="老师周测成绩次数" :visible.sync="visibleAchievement" width="80%" @close="handleClearListAchievement">
        <el-form :inline="true" label-width="100px" style=" display: flex;">
          <el-form-item label="老师名称" style="display: flex; ">
            <el-select filterable clearable placeholder="请选择老师名称" v-model="achievementlist.teacherId"
              style="width:300px">
              <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                :label="teacher.realname" :value="teacher.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期:" style="display: flex; ">
            <el-date-picker v-model="achievementlist.timer" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-col>
            <el-button type="primary" icon="el-icon-search" @click="searchStudentAchievement" size="small"
              class="btns">查询</el-button>
            <el-button @click="handleClearListAchievement" class="btns" size="small" icon="el-icon-close">清除</el-button>
          </el-col>

        </el-form>



        <div style="line-height: 40px; float: left;">周测成绩总次数：{{ weeklyTestlistCountList.weeklyTestCount ?
          weeklyTestlistCountList.weeklyTestCount : "0"}}次</div>
        <el-table :data="weeklyTestlistCountList.weeklyTest" border style="width: 100%">
          <el-table-column prop="teacherName" label="老师姓名" width="180">
          </el-table-column>
          <el-table-column prop="teacherRankName" label="老师职级">
          </el-table-column>
          <el-table-column prop="period" label="学段" width="180">
          </el-table-column>
          <el-table-column prop="discipline" label="学科" width="180">
          </el-table-column>
          <el-table-column prop="detailedGradesStr" label="分数" width="180">
            <template slot-scope="scope">
              <div v-for="( itme, index ) in scope.row.detailedGradesStr" :key="index">
                <span>{{ itme.score }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedGradesStr" label="日期" width="180">
            <template slot-scope="scope">
              <div v-for="( itme, index ) in scope.row.detailedGradesStr" :key="index">
                <span>{{ itme.date }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="line-height: 40px; float: left;">周测成绩达到优异次数：{{ weeklyTestlistCountList.excellentCount ?
          weeklyTestlistCountList.excellentCount : '0' }}次</div>
        <el-table :data="weeklyTestlistCountList.excellent" border style="width: 100%">
          <el-table-column prop="teacherName" label="老师姓名" width="180">
          </el-table-column>
          <el-table-column prop="teacherRankName" label="老师职级">
          </el-table-column>
          <el-table-column prop="period" label="学段" width="180">
          </el-table-column>
          <el-table-column prop="discipline" label="学科" width="180">
          </el-table-column>
          <el-table-column prop="detailedGradesStr" label="分数" width="180">
            <template slot-scope="scope">
              <div v-for="( itme, index ) in scope.row.detailedGradesStr" :key="index">
                <span>{{ itme.score }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="detailedGradesStr" label="日期" width="180">
            <template slot-scope="scope">
              <div v-for="( itme, index ) in scope.row.detailedGradesStr" :key="index">
                <span>{{ itme.date }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>



      </el-dialog>

      <div class="footer-button">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="fromState.pageNum" :page-size="fromState.pageSize" layout="total, prev, pager, next"
          :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
//   import EditStudents from "./EditStudents.vue";
import { weeklyTestListAPI, addWeeklyTestListAPI, getOneWeeklyTesttAPI, updateEeeklyTestAPI, getWeeklyTestlistCountAPI } from "@/api/weeklyTest.js"
export default {
  //  name: "StudentList",
  // components: { EditStudents },
  data() {
    return {
      input3: '',
      teachers: '',
      // optionList4:'',
      optionList4: [{ tepys: "数学", value: 1 }, { tepys: "英语", value: 2 }, { tepys: "语文", value: 3 }, { tepys: '生物', value: 4 }, { tepys: '物理', value: 5 }, { tepys: '化学', value: 6 }, { tepys: '地理', value: 7 }, { tepys: '历史', value: 8 }, { tepys: '政治', value: 9 }],
      showEiet: false,
      prestoreHoursNum: 0,
      eliminateHoursNum: 0,
      arrearsHoursNum: 0,
      gradeList: [],
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      studentData: [],
      searchTeachers: "",
      achievementlist: {
        teacherId: '',
        timer: [],
      },
      editFormData: {
        ids: '',
        id: '',
        jobname: '',
        Grade: '',
        Subject: '',
        listData: [{
          score: '',
          date: '',
          isExcellent: '',
        }],

      },

      // progressTeacherName: [],
      Progressteacher: [],
      Progressteacher1: [],
      teacherData: [],
      sourcesPeople: [],
      salesName: [],
      keyword: "",
      fromState: {
        teacherId: '',
        period: '',
        discipline: '',
        pageNo: 1,
        pageSize: 10,
        timer: [],
        page: 1,
        pageSize: 10,
        regionName:''
      },

      total: 0,
      currentPath: this.$route.path,
      visibleForm: false,
      visibleDetails: false,
      visibleDialog: false, //添加学生
      visibleAchievement: false,

      weeklyTestList: [],
      titleTepy: true,
      getStudentsArr: [],
      detaiList: {},
      tableData: {},
      weeklyTestlistCountList: {},

      isTrue: true,

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],


    };
  },

  watch: {
    '$route.path': function (newVal, oldVal) {
      this.currentPath = newVal;
    }
  },

  created() {
    this.weeklyTestLists()
  },
  mounted() {

    axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.teachers = [...response.data.data]

      })
      .catch(error => {
        console.error(error);
      });

    axios.get(`${apiBaseUrl}/teacher/query/job`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      this.getStudentsArr = res.data.data.list
    }).catch(error => {
      
    })


    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },
  methods: {
    weeklyTestLists() {
      let data = {
        teacherId: this.fromState.teacherId,
        period: this.fromState.period,
        discipline: this.fromState.discipline,
        startDate: this.fromState.timer[0],
        endDate: this.fromState.timer[1],
        pageNo: this.fromState.page,
        pageSize: this.fromState.pageSize,
        regionName:this.fromState.regionName || localStorage.getItem('cityTepy'),
      }
      weeklyTestListAPI(data).then(res => {
        if (res.code === 200) {
          if(res.data === null){
            this.weeklyTestList = []
          }else{
            this.weeklyTestList = res.data.list
          }
          
          
          this.total = res.data.allTotal
        }
      })
    },

    handleSplice(arr, index) {
      return arr.splice(index, 1)
    },

    handleAdd(type, index) {
      if (type === 2) {
        if (index === 0) {
          this.$message({ message: '已经是最后一项了~', type: 'warning' })
        } else {
          this.handleSplice(this.editFormData.listData, index)
        }
      } else {
        this.editFormData.listData.push(index)
      }
    },
    count() {
      axios
        .get(`${apiBaseUrl}/student/calculate`, {
          headers: {
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.allStudent();
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    //获取年级
    getGrade() {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`, {
          headers: {
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          
        });
    },
    refresh() {
      this.allStudent();
    },
    //客资来源负责人
    getDataSoursePeople() {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`, {
          headers: {
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.sourcesPeople = response.data.data.list;

        })
        .catch(error => {
          console.error(error);
        });
    },
    //销售
    teacherSale() {
      axios
        .get(`${apiBaseUrl}/teacher/teacherSale`, {
          headers: {
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.salesName = response.data.data
          // this.Progressteacher = response.data.data  //跟进老师
          // 
          // 
          this.Progressteacher1 = response.data.data; //跟进老师
          // 
          // 
          // 
        })
        .catch(error => {
          console.error(error);
        });
    },
    //跟进老师
    getTeacher() {
      axios.get(`${apiBaseUrl}/schedule/assistantList`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        // this.salesName = response.data.data
        // this.Progressteacher = response.data.data  //跟进老师
        // 
        // 
        this.Progressteacher = response.data.data; //跟进老师
        // 
        // 
        // 
      })
        .catch(error => {
          console.error(error);
        });
    },

    //选中学员事件
    handleSelectionChange(arr) {
      const aa = [];
      for (let i = 0; i < arr.length; i++) {
        aa.push(arr[i].id);
      }
      this.teacherId = aa;
    },
    // 清空年级回到查询所有学生
    gradeListener() {
      this.allStudent();
      this.value2 = "";
    },

    // 清空班级回到查询所有班级
    classListener() { },

    // 查询班级信息
    queryClass() {
      this.$axios
        .get(`${apiBaseUrl}/class-grade/` + this.value1, {
          headers: {
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          let ret = res.data.data;
          this.classNo.splice(0, this.classNo.length);
          this.value2 = "";
          ret.map(v => {
            this.classNo.push({
              value: v.classNo,
              label: v.className
            });
          });
        })
        .catch(error => { });
    },

    cancelUpd() {
      this.visibleForm = false;
      this.editFormData = {
        id: '',
        jobname: '',
        Grade: '',
        Subject: '',
        listData: [{
          score: '',
          date: '',
          isExcellent: '',
        }]
      }
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
    },

    cancel() {
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
      this.visibleDialog = false;
      this.$refs.editFormData.clearValidate();
    },




    handleClearList() {
      this.fromState = {
        teacherId: '',
        period: '',
        discipline: '',
        page: 1,
        pageSize: 10,
        timer: [],
        regionName:''
      }
      this.weeklyTestLists()
    },
    handleClearListAchievement() {

      this.achievementlist.teacherId = ''
      this.achievementlist.timer = []
      this.achievementlist.timer[0] = ''
      this.achievementlist.timer[1] = ''
      this.weeklyTestlistCountList = {}
    },
    //关键字查询学生
    searchStudent() {
      this.fromState.page = 1
      if (this.fromState.progressTeacherName != '' || this.fromState.saleName != '' || this.fromState.sourcepeopleId != '') {
        this.fromState.pageSize = 500
      }
      this.weeklyTestLists()
    },

    searchStudentAchievement() {
      this.getWeeklyTestlistCount()
    },

    getWeeklyTestlistCount() {
      let data = {
        teacherId: this.achievementlist.teacherId,
        startDate: this.achievementlist.timer[0],
        endDate: this.achievementlist.timer[1],
      }
      getWeeklyTestlistCountAPI(data).then(res => {
        
        if (res.code === 200) {
          
          if(res.data === null){
            this.weeklyTestlistCountList = []
          }else{
          this.weeklyTestlistCountList = res.data
          }
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)

        }
      })
    },


    //点击添加按钮
    addStudent() {
      this.showEiet = false
      this.$nextTick(() => {
        this.$refs.editStudents.init();
      });
    },
    //按回车搜索姓名查询
    handleSearch() {
      if (this.searchTeachers) {
        // 
        this.addStudent();
        // 清空搜索框
        // this.name = "";
      }
    },

    //详情
    details(index, row) {
      this.visibleDetails = true
      getOneWeeklyTesttAPI(row.id).then(res => {
        
        if (res.code === 200) {
          this.detaiList = res.data
          
        }
      })

    },
    // 点击编辑学生回显数据
    editById(tepys, index, row) {
      this.visibleForm = true
      if (tepys === 1) {
        this.titleTepy = true

      } else {
        this.titleTepy = false
        this.editFormData.ids = row.id
        this.editFormData.id = row.teacherId
        this.editFormData.jobname = row.teacherRank
        this.editFormData.Grade = row.period
        this.editFormData.Subject = row.discipline
        this.editFormData.listData = [...row.detailedGradesStr]
      }
      // let modifyId = row.id;
      // 
    },
    editAchievement() {
      this.visibleAchievement = true
    },


    handleIsTrue(){
      if(this.isTrue){
            let data = {
              teacherId: this.editFormData.id,
              teacherRank: this.editFormData.jobname,
              period: this.editFormData.Grade,
              discipline: this.editFormData.Subject,
              detailedGrades: JSON.stringify(this.editFormData.listData)
            }
            addWeeklyTestListAPI(data).then(res => {
              this.visibleForm = false
              if (res.code === 200) {
                this.editFormData = {
                  ids: '',
                  id: '',
                  jobname: '',
                  Grade: '',
                  Subject: '',
                  listData: [{
                    score: '',
                    date: '',
                    isExcellent: '',
                  }]
                }

                this.weeklyTestLists()
                this.$message.success(res.message)
              } else {
                this.editFormData = {
                  ids: '',
                  id: '',
                  jobname: '',
                  Grade: '',
                  Subject: '',
                  listData: [{
                    score: '',
                    date: '',
                    isExcellent: '',
                  }]
                }
                this.$message.error(res.message)
              }
            })
          }else{
            this.$message.warning('请填写全部周测考试信息~')
          }
    },

    // 添加 ，编辑
    commit() {

      if (this.titleTepy) {
        if (this.editFormData.id === '') {
          this.$message.warning('请选择老师名称')
        } 
        else if (this.editFormData.jobname === '') {
          this.$message.warning('请选择老师职级')
        } 
        else if (this.editFormData.Subject === '') {
          this.$message.warning('请选择学科')
        }
         else if (this.editFormData.Grade === '') {
          this.$message.warning('请选择学段')
        } 
        else if (this.editFormData.listData[0].score === '' || this.editFormData.listData[0].date === '' || this.editFormData.listData[0].isExcellent === '' ) {
          this.$message.warning('请输入周测考试信息~')
        }
        else if (this.editFormData.listData.length > 1 && this.editFormData.listData.length < 3) {
          this.editFormData.listData.map((itme,index)=>{
            if(index > 0){
              if(itme.score){
                if(itme.date){
                   this.isTrue = true
                   this.handleIsTrue()
                }else{
                  this.isTrue = false
                  this.$message.warning('请填写第' + (index + 1) + '周日期~')
                }
              }else{
                this.isTrue = true
                this.handleIsTrue()
              }
            }
          })
          // this.handleIsTrue()
        }else{
          this.handleIsTrue()

        }

      } else {
        let data = {
          id: this.editFormData.ids,
          teacherId: this.editFormData.id,
          teacherRank: this.editFormData.jobname,
          period: this.editFormData.Grade,
          discipline: this.editFormData.Subject,
          detailedGrades: JSON.stringify(this.editFormData.listData)
        }
        updateEeeklyTestAPI(data).then(res => {
          this.visibleForm = false
          if (res.code === 200) {
            this.editFormData = {
              ids: '',
              id: '',
              jobname: '',
              Grade: '',
              Subject: '',
              listData: [{
                score: '',
                date: '',
                isExcellent: '',
              }]
            }

            this.weeklyTestLists()
            this.$message.success(res.message)
          } else {
            this.editFormData = {
              ids: '',
              id: '',
              jobname: '',
              Grade: '',
              Subject: '',
              listData: [{
                score: '',
                date: '',
                isExcellent: '',
              }]
            }
            this.$message.error(res.message)
          }

        })
      }

    },



    handleSizeChange(val) {
      
    },

    handleCurrentChange(v) {
      this.fromState.page = v;
      this.weeklyTestLists()
    },
    //点击姓名出现弹层
    highlightRow(index) {
      // 清除之前的高亮状态
      if (this.highlightedIndex !== -1) {
        // 假设表格组件提供了清除高亮的方法，如 clearHighlight
        this.$refs.table.clearHighlight();
      }
      // 设置当前行为高亮状态
      // 假设表格组件提供了设置高亮的方法，如 highlightRow
      this.$refs.table.highlightRow(index);
      this.highlightedIndex = index;
    }
  }

};
</script>

<style scoped>
.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 70%;
  }

  .el-input-group {
    width: 60%;
  }

  .sex {
    margin-left: -15% !important;
  }
}

.btns {
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.namestyle {
  display: flex;
  justify-content: space-evenly;
}

.weekstyle {
  display: flex;
  justify-content: space-evenly;
}

.centstyle {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/WeeklyTestPerformanceManagement/WeeklyTestScoreViewing.vue